import React, {Component} from 'react'
import PropTypes from 'prop-types'
import wrappedIntlComponent from "./common/intl/WrappedIntlComponent"
import {connect} from 'react-redux'
import {modalsSelector, MODAL_CARD_FORM, CREATE_DIALOG, QBM_CRUD, MODAL_FORM_QBM, QBM_SEND, QBM_USER_BOOKS, ADD_MEDIA, CONFIRM, SELECT, SELECT3, RENDER_BODY, TRASHED_QUESTION_MODAL, TEMP_QUESTION_MODAL, IMPORT_EXPORT_QUESTIONS_MODAL, INFO, POPOVER, Q_LOADER, MODAL_ROOM_FORM, MODAL_ROOM_DELETE, QBM_QUIZ, MODAL_QUIZ_DELETE, MODAL_QUESTION_QUIZ_DELETE, MODAL_STUDENT_FORM, MODAL_STUDENT_FORM_VIEW, MODAL_ADD_STUDENT_ROOM, MODAL_USERS_ROOMS, MODAL_FOLDER_FORM, MODAL_FOLDER_DELETE, MODAL_PRESENTATION_FORM, MODAL_PRESENTATION_DELETE, MODAL_PRESENT_ITEM_DELETE, QBM_PRESENTATION, MODAL_VIDE_INFO, MODAL_FORM_UPDATE_QUIZS, MODAL_FORM_TEACHER, MODAL_QUESTION_TRASHED_DELETE, MODAL_QUESTION_TRASHED_RECOVERY, QBM_CLEAR_STATISTIC_FORM, MODAL_PRESENTATION_COPY, MODAL_CARD_SUBJECT_FORM, MODAL_CARD_SUBJECT_DELETE, MODAL_CARD_CATEGORY_FORM, MODAL_CARD_CATEGORY_DELETE, MODAL_CARD_CATEGORY_FRAME, MODAL_CARD_FORM_TRASHED, QBM_SHARED_QUESTION, MODAL_QUESTION_MULTY_SUBJECT_FORM, MODAL_QUESTION_MULTY_CATEGORY_FORM, MODAL_QUESTION_MULTY_CATEGORY_DELETE, MODAL_QUESTION_MULTY_SUBJECT_DELETE, MODAL_QUESTION_MULTY_FORM, MODAL_QUESTION_MULTY_CATEGORY_FRAME, MODAL_SLIDER_FOLDER_FORM, MODAL_SLIDER_FOLDER_DELETE, MODAL_SLIDER_FORM, MODAL_SLIDER_DELETE, MODAL_SLIDER_SHARE} from '../modules/modals'
import CreateDialogModal from './Support/CreateDialogModal'
import QbmCrudModal from './QbmPage/QbmCrudModal'
import QbmSendModal from './QbmPage/QbmSendModal'
import QbmUserBooks from './QbmPage/QbmUserBooks'
import AddMediaModal from './QbmPage/QbmBody/TextEditor/AddMediaModal'
import Confirm from './modals/common/Confirm'
import Select from './modals/common/Select'
import Select3 from './modals/common/Select3'
import RenderBody from './modals/common/RenderBody'
import TrashedQuestionFormModal from './QbmPage/QbmBody/QuestionForm/TrashedQuestionFormModal'
import TempQuestionFormModal from './QbmPage/QbmBody/QuestionForm/TempQuestionFormModal'
import ImportExport from './modals/ImportExport'
import InfoModal from './modals/common/Info'
import Popover from './modals/common/Popover'
import QlogoLoader from './common/QlogoLoader'
import FormModalCard from './Card/components/CardModal/CardModal'
import FormModalCardSubject from './Card/components/Subject/components/FormModal'
import FormModalCardCategory from './Card/components/Category/components/FormModal'
import FormModalCardCategoryFrame from './Card/components/Category/components/FrameModal'
import DeleteModalCardSubject from './Card/components/Subject/components/DeleteModal'
import DeleteModalCardCategory from './Card/components/Category/components/DeleteModal'
import FormModalRoom from './RoomsAndStudents/Rooms/components/FormModal'
import DeleteModalRoom from './RoomsAndStudents/Rooms/components/DeleteModal'

import FormModalQuestion from './Question/components/QuestionModal/QuestionModal'
import FormModalQuestionSubject from './Question/components/Subject/components/FormModal'
import FormModalQuestionCategory from './Question/components/Category/components/FormModal'
import FormModalQuestionCategoryFrame from './Question/components/Category/components/FrameModal'
import DeleteModalQuestionSubject from './Question/components/Subject/components/DeleteModal'
import DeleteModalQuestionCategory from './Question/components/Category/components/DeleteModal'

import QbmQuiz from './QbmPage/QbmQuiz'
import DeleteModalQuiz from './Quizs/components/DeleteModal'
import UsersModal from './Quizs/components/Room/UsersModal'
import DeleteModalQuizQuestion from './Quiz/components/Questions/DeleteModal'
import FormModalStudent from './Students/components/FormModal'
import FormModalStudentView from './Students/components/FormView'
import FormAddStudentRoom from './RoomsAndStudents/Students/components/FormAddStudentRoom'

import FormModalFolder from './Presentations/components/Folders/components/FormModal'
import DeleteModalFolder from './Presentations/components/Folders/components/DeleteModal'

import FormModalSliderFolder from './Sliders/components/Folders/components/FormModal'
import DeleteModalSliderFolder from './Sliders/components/Folders/components/DeleteModal'
import FormModalSlider from './Sliders/components/PresentationItems/components/FormModal'
import FormModalSliderDelete from './Sliders/components/PresentationItems/components/DeleteModal'
import FormModalSliderShare from './Sliders/components/PresentationItems/components/ShareModal'

import FormModalPresentation from './Presentations/components/PresentationItems/components/FormModal'
import CopyModalPresentation from './Presentations/components/PresentationItems/components/CopyModal'
import DeleteModalPresentation from './Presentations/components/PresentationItems/components/DeleteModal'
import DeleteModalPresentationItem from './Presentation/components/Sliders/components/Actions/DeleteForm'
import QbmPresentation from './QbmPage/QbmPresentation'
import VideoModal from './Presentations/components/VideoModal'
import ModalFormQbm from './QbmPage/ModalFormQbm/ModalFormQbm'
import ModalFormUpdateQuizs from './Quizs/components/ModalUpdateQuizs'
import ModalFormTeacher from './UserOrganisation/components/ModalForm/ModalFormTeacher'
import DeleteModalTrashedQuestion from './Trashed/components/DeleteModal'
import RecoveryModalTrashedQuestion from './Trashed/components/RecoveryModal'
import ClearStatisticForm from './QbmPage/ClearStatisticForm/ClearStatisticForm'
import CardFormTrashed from './CardTrashed/components/CardFormTrashed/CardFormTrashed'
import ModalSharedQuestion from './QbmPage/QbmBody/QuestionForm/components/ModalSharedQuestion/ModalSharedQuestion'

const MODAL_COMPONENTS = {
    [MODAL_USERS_ROOMS] : UsersModal,
    [MODAL_QUESTION_MULTY_SUBJECT_FORM] : FormModalQuestionSubject,
    [MODAL_QUESTION_MULTY_SUBJECT_DELETE] : DeleteModalQuestionSubject,
    [MODAL_QUESTION_MULTY_CATEGORY_FORM] : FormModalQuestionCategory,
    [MODAL_QUESTION_MULTY_CATEGORY_FRAME] : FormModalQuestionCategoryFrame,
    [MODAL_QUESTION_MULTY_CATEGORY_DELETE] : DeleteModalQuestionCategory,
    [MODAL_QUESTION_MULTY_FORM] : FormModalQuestion,
    [MODAL_CARD_SUBJECT_FORM] : FormModalCardSubject,
    [MODAL_CARD_FORM] : FormModalCard,
    [MODAL_CARD_FORM_TRASHED] : CardFormTrashed,
    [MODAL_CARD_CATEGORY_FORM] : FormModalCardCategory,
    [MODAL_CARD_CATEGORY_FRAME] : FormModalCardCategoryFrame,
    [MODAL_CARD_CATEGORY_DELETE] : DeleteModalCardCategory,
    [MODAL_CARD_SUBJECT_DELETE] : DeleteModalCardSubject,
    [CREATE_DIALOG] : CreateDialogModal,
    [QBM_CRUD] : QbmCrudModal,
    [MODAL_VIDE_INFO] : VideoModal,
    [QBM_SEND] : QbmSendModal,
    [QBM_QUIZ] : QbmQuiz,
    [QBM_SHARED_QUESTION] : ModalSharedQuestion,
    [MODAL_FORM_QBM] : ModalFormQbm,
    [MODAL_FORM_UPDATE_QUIZS] : ModalFormUpdateQuizs,
    [MODAL_FORM_TEACHER] : ModalFormTeacher,
    [QBM_PRESENTATION] : QbmPresentation,
    [QBM_CLEAR_STATISTIC_FORM] : ClearStatisticForm,
    [QBM_USER_BOOKS] : QbmUserBooks,
    [MODAL_ROOM_FORM] : FormModalRoom,
    [MODAL_FOLDER_FORM] : FormModalFolder,
    [MODAL_SLIDER_FOLDER_FORM] : FormModalSliderFolder,
    [MODAL_FOLDER_DELETE] : DeleteModalFolder,
    [MODAL_SLIDER_DELETE] : FormModalSliderDelete,
    [MODAL_SLIDER_SHARE] : FormModalSliderShare,
    [MODAL_SLIDER_FOLDER_DELETE] : DeleteModalSliderFolder,
    [MODAL_SLIDER_FORM] : FormModalSlider,
    [MODAL_PRESENTATION_FORM] : FormModalPresentation,
    [MODAL_PRESENTATION_COPY] : CopyModalPresentation,
    [MODAL_PRESENTATION_DELETE] : DeleteModalPresentation,
    [MODAL_STUDENT_FORM] : FormModalStudent,
    [MODAL_STUDENT_FORM_VIEW] : FormModalStudentView,
    [MODAL_ADD_STUDENT_ROOM] : FormAddStudentRoom,
    [MODAL_ROOM_DELETE] : DeleteModalRoom,
    [MODAL_QUIZ_DELETE] : DeleteModalQuiz,
    [MODAL_PRESENT_ITEM_DELETE] : DeleteModalPresentationItem,
    [MODAL_QUESTION_QUIZ_DELETE] : DeleteModalQuizQuestion,
    [MODAL_QUESTION_TRASHED_DELETE] : DeleteModalTrashedQuestion,
    [MODAL_QUESTION_TRASHED_RECOVERY] : RecoveryModalTrashedQuestion,
    [ADD_MEDIA] : AddMediaModal,
    [CONFIRM] : Confirm,
    [SELECT] : Select,
    [SELECT3] : Select3,
    [RENDER_BODY] : RenderBody,
    [TRASHED_QUESTION_MODAL] : TrashedQuestionFormModal,
    [TEMP_QUESTION_MODAL] : TempQuestionFormModal,
    [IMPORT_EXPORT_QUESTIONS_MODAL] : ImportExport,
    [INFO] : InfoModal,
    [POPOVER] : Popover,
    [Q_LOADER] : QlogoLoader,
}

class ModalRoot extends Component {
    static childContextTypes = {
        formatMessage: PropTypes.any,
    }
    getChildContext() {
        return {
            formatMessage: this.props.formatMessage,
        }
    }
    render() {
        let {modals} = this.props
        if (!modals.length) return null

        return modals.map(({type, zIndex, props}) => {
            const SpecificModal = MODAL_COMPONENTS[type]
            if (!SpecificModal) return null
            return <SpecificModal key = {type} zIndex = {zIndex} {...props} />
        })
    }
}

export default connect(
    state => ({
        modals : modalsSelector(state)
    })
)(wrappedIntlComponent(ModalRoot))


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/ModalRoot.js